import type {DiscriminatedUnion} from '@gl/lit/types/union.js';

export function createDiscriminator<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  U extends DiscriminatedUnion<string, any>,
  R,
>() {
  return function <K extends PropertyKey>(key: K) {
    return function (union: U) {
      return function (handlers: {
        [P in U[K]]: U extends Record<K, P>
          ? (data: Extract<U, Record<K, P>>) => R
          : never;
      }): R {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return handlers[union[key] as U[K]](union as any);
      };
    };
  };
}
